/**
 * Returns array of indexes of skus which are present in utagA and not present in utagB
 * @param {Object} utagA utag_data
 * @param {Object} utagB utag_data
 * @returns {Array} array of indexes of excluded skus
 */
const getExcludedIndexes = (utagA, utagB) => utagA.product_sku?.reduce((acc, sku, i) => {

	if (!utagB.product_sku.includes(sku)) {

		acc.push(i);

	}
	return acc;

}, []) ?? [];

export default getExcludedIndexes;
